export default [
  {
    name: 'contract',
    path: '/contract/manage',
    component: () => import('../views/contract/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'bill-check',
    path: '/bill/bill-check',
    component: () => import('../views/bill/bill-check'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'channel-cost-config',
    path: '/channel-cost/config',
    component: () => import('../views/rebate/channel-cost-config/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'channel-cost-list',
    path: '/channel-cost/list',
    component: () => import('../views/rebate/channel-cost-list/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'channel-cost-apply',
    path: '/channel-cost/apply',
    component: () => import('../views/rebate/channel-cost-apply/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'capital-pool-typeB',
    path: '/capital-pool/typeB',
    component: () => import('../views/capital-pool/type-b/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'B类资金池明细',
    path: '/capital-pool/typeB/detail',
    component: () => import('../views/capital-pool/type-b-detail/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'capital-pool-cash',
    path: '/capital-pool/cash',
    component: () => import('../views/capital-pool/cash/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: '现金流资金池明细',
    path: '/capital-pool/cash/detail',
    component: () => import('../views/capital-pool/cash-detail/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'goods-replenish',
    path: '/capital-pool/goods-replenish',
    component: () => import('../views/capital-pool/goods-replenish/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: '货补池明细',
    path: '/capital-pool/goods-replenish/detail',
    component: () => import('../views/capital-pool/goods-replenish-detail/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: '货补池明细',
    path: '/capital-pool/goods-replenish/detail',
    component: () => import('../views/capital-pool/goods-replenish-detail/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'need-goods',
    path: '/order/need-goods/list',
    component: () => import('../views/order/need-goods/table/table'),
    meta: {
      keepAlive: false,
    },
  },

  {
    name: 'need_goods_simple',
    path: '/order/need-goods/need_goods_simple',
    component: () => import('../views/order/need_goods_simple/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'need_goods_config',
    path: '/order/need-goods/need_goods_config',
    component: () => import('../views/order/need_goods_config'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'need_goods_detail',
    path: '/order/need_goods_detail',
    component: () => import('../views/order/need_goods_detail/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'low-price',
    path: '/other/low-price/list',
    component: () => import('../views/other/low-price/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'counterfeiting',
    path: '/other/counterfeiting/list',
    component: () => import('../views/other/counterfeiting/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'back',
    path: '/order/back/list',
    component: () => import('../views/order/back/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'anxious',
    path: '/order/anxious/list',
    component: () => import('../views/order/anxious/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'urgently_needed_detail',
    path: '/order/urgently_needed_detail',
    component: () => import('../views/order/urgently_needed_detail'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'send',
    path: '/order/send/list',
    component: () => import('../views/order/send/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'invoice',
    path: '/order/invoice/list',
    component: () => import('../views/order/invoice/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'quota_management',
    path: '/order/quota_management',
    component: () => import('../views/order/quota_management'),
    meta: {
      keepAlive: true,
      title: '配额管理',
    },
  },
  {
    name: 'dealer_quota_management',
    path: '/order/dealer_quota_management',
    component: () => import('../views/order/dealer_quota_management'),
    meta: {
      keepAlive: true,
      title: '经销商配额管理',
    },
  },
  {
    name: 'dealer_quota_report',
    path: '/order/dealer_quota_report',
    component: () => import('../views/order/dealer_quota_report'),
    meta: {
      keepAlive: true,
      title: '经销商配额报表',
    },
  },
  // 要货计划明细
  {
    name: 'demand_plan_detail',
    path: '/order/demand_plan_detail/list',
    component: () => import('../views/order/demand_plan_detail/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'significance',
    path: '/order/significance/list',
    component: () => import('../views/order/significance/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'remittance',
    path: '/bill/remittance/list',
    component: () => import('../views/bill/remittance/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'reconciliation',
    path: '/bill/reconciliation/list',
    component: () => import('../views/bill/reconciliation/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'capital-account',
    path: '/bill/capital-account/list',
    component: () => import('../views/bill/capital-account/table/table'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'anxious_detail_report',
    path: '/order/anxious_detail_report',
    component: () => import('../views/order/anxious_detail_report/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_a',
    path: '/new_column/column_a',
    component: () => import('../views/new-column/column-a/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_b',
    path: '/new_column/column_b',
    component: () => import('../views/new-column/column-b/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_c',
    path: '/new_column/column_c',
    component: () => import('../views/new-column/column-c/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_d',
    path: '/new_column/column_d',
    component: () => import('../views/new-column/column-d/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_e',
    path: '/new_column/column_e',
    component: () => import('../views/new-column/column-e/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_f',
    path: '/new_column/column_f',
    component: () => import('../views/new-column/column-f/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_g',
    path: '/new_column/column_g',
    component: () => import('../views/new-column/column-g/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_h',
    path: '/new_column/column_h',
    component: () => import('../views/new-column/column-h/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_i',
    path: '/new_column/column_i',
    component: () => import('../views/new-column/column-i/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_j',
    path: '/new_column/column_j',
    component: () => import('../views/new-column/column-j/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_k',
    path: '/new_column/column_k',
    component: () => import('../views/new-column/column-k/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_l',
    path: '/new_column/column_l',
    component: () => import('../views/new-column/column-l/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_m',
    path: '/new_column/column_m',
    component: () => import('../views/new-column/column-m/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_n',
    path: '/new_column/column_n',
    component: () => import('../views/new-column/column-n/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_o',
    path: '/new_column/column_o',
    component: () => import('../views/new-column/column-o/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_p',
    path: '/new_column/column_p',
    component: () => import('../views/new-column/column-p/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_q',
    path: '/new_column/column_q',
    component: () => import('../views/new-column/column-q/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_r',
    path: '/new_column/column_r',
    component: () => import('../views/new-column/column-r/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_s',
    path: '/new_column/column_s',
    component: () => import('../views/new-column/column-s/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_t',
    path: '/new_column/column_t',
    component: () => import('../views/new-column/column-t/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_a1',
    path: '/new_column/column_a1',
    component: () => import('../views/new-column/column-a1/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_a2',
    path: '/new_column/column_a2',
    component: () => import('../views/new-column/column-a2/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_a3',
    path: '/new_column/column_a3',
    component: () => import('../views/new-column/column-a3/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_a4',
    path: '/new_column/column_a4',
    component: () => import('../views/new-column/column-a4/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_a5',
    path: '/new_column/column_a5',
    component: () => import('../views/new-column/column-a5/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_a6',
    path: '/new_column/column_a6',
    component: () => import('../views/new-column/column-a6/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_a7',
    path: '/new_column/column_a7',
    component: () => import('../views/new-column/column-a7/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_a8',
    path: '/new_column/column_a8',
    component: () => import('../views/new-column/column-a8/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_a9',
    path: '/new_column/column_a9',
    component: () => import('../views/new-column/column-a9/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_a10',
    path: '/new_column/column_a10',
    component: () => import('../views/new-column/column-a10/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_a11',
    path: '/new_column/column_a11',
    component: () => import('../views/new-column/column-a11/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_a12',
    path: '/new_column/column_a12',
    component: () => import('../views/new-column/column-a12/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_a13',
    path: '/new_column/column_a13',
    component: () => import('../views/new-column/column-a13/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_a14',
    path: '/new_column/column_a14',
    component: () => import('../views/new-column/column-a14/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_a15',
    path: '/new_column/column_a15',
    component: () => import('../views/new-column/column-a15/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_a16',
    path: '/new_column/column_a16',
    component: () => import('../views/new-column/column-a16/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_a17',
    path: '/new_column/column_a17',
    component: () => import('../views/new-column/column-a17/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_a18',
    path: '/new_column/column_a18',
    component: () => import('../views/new-column/column-a18/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_a19',
    path: '/new_column/column_a19',
    component: () => import('../views/new-column/column-a19/index'),
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'column_a20',
    path: '/new_column/column_a20',
    component: () => import('../views/new-column/column-a20/index'),
    meta: {
      keepAlive: false,
    },
  },
];
